import { useEffect, useState } from "react"
import i18n from "../../../../i18n"
import ProductOptions from "./ProductOptions"

const ProductReservationCard = ({product, cart, setCart}) => {
    const [quantity, setQuantity] = useState(0)
    const [people, setPeople] = useState(1)
    const [message, setMessage] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState({})
    const cartItemQ = cart[product.id]?.quantity

    useEffect(() => {
        setQuantity(cartItemQ || 0)
    }, [cartItemQ])

    // Initialize selected options and people from cart if available
    useEffect(() => {
        if (cart[product.id]?.options) {
            setSelectedOptions(cart[product.id].options)
        }
        if (cart[product.id]?.people) {
            setPeople(cart[product.id].people)
        }
    }, [product.id])

    useEffect(() => {
        setCart(cart => ({
            ...cart, 
            [product.id]: {
                id: product.id, 
                quantity: quantity, 
                price: product.price, 
                total_price: product.price * quantity, 
                name: product.name,
                options: selectedOptions,
                people: people
            }
        }))
    }, [product.id, product.price, product.name, quantity, selectedOptions, people, setCart])

    // Clear message after 2 seconds
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage(null)
            }, 2000)
            return () => clearTimeout(timer)
        }
    }, [message])
    return (
        <div className='card flex-column mt-1 col-12 flex-row p-3 d-flex align-items-center' key={product.id}>
            {message && <p className='position-absolute end-0 top-0 product-message mb-0 ' style={{zIndex: '100'}}>{message}</p>}
            <div className="row w-100">
                <div className="col-4 col-lg-3">
                    {product.image_object?.image && <img src={product.image_object?.image} alt={product.name} className='img-fluid ' style={{ objectFit: 'contain'}} />}
                </div>
                <div className='product-information d-flex align-items-start px-1 px-md-3 col'>
                    <div className="product-information-content col d-flex flex-column h-100">
                        <h5 className='product-name mb-0 ' style={{fontSize: '1rem'}}>
                            {product.name}
                        </h5>
                        <p className='product-description mb-0 mt-1 p-0 ' style={{fontSize: '0.875rem'}}>
                            {product.short_description}<br></br>
                        </p>
                        <div className="badge mt-auto" style={{backgroundColor: 'var(--umr-primary)', fontSize: '0.875rem', width: 'fit-content'}}>
                            €{product.price} {product.calc_pricing_type_display}
                        </div>
                    </div>
                    <div className="product-quantity d-flex flex-column my-auto  col-4" >
                        <p className="product-quantity-label">{i18n.t('Aantal')}</p>
                        <div class="btn-group " role="group" aria-label="Small button group">
                            <div 
                                className="py-1 btn btn-outline-light text-dark d-flex justify-content-center align-items-center" 
                                onClick={() => {
                                    setMessage(null); 
                                    setQuantity( (q) => {
                                        const newQty = q===0 ? 0 : q-1
                                        if (newQty === 0) {
                                            setSelectedOptions({})
                                        }
                                        return newQty
                                    })
                                }}
                                type="button" id="button-plus"> 
                                - 
                            </div>
                            <input 
                                data-id={product.id} 
                                name={product.id+ '_quantity'} 
                                type="text" 
                                min={1}
                                disabled={product.available_listings === 0}
                                class="btn btn-quantity btn-outline-light form-control text-dark pe-0"  
                                onChange={e => {
                                    if(product.available_listings === 0) {
                                        return
                                    }
                                    setMessage(null); 
                                    const val = parseInt(e.target.value) || 0
                                    if(val >= product.available_listings){
                                        setQuantity(product.available_listings);
                                        setMessage(<span className="alert alert-warning">{i18n.t('Je hebt het maximum beschikbare bereikt')}</span>) 
                                    } else {
                                        setQuantity(val)
                                        if (val === 0) {
                                            setSelectedOptions({})
                                        }
                                    }
                                }}
                                value={quantity} />
                            <div
                                className="py-1 btn btn-outline-light text-dark d-flex justify-content-center align-items-center" 
                                type="button" 
                                disabled={product.available_listings === 0}
                                onClick={() => setQuantity( (q) => {
                                    if(q===product.available_listings){
                                        setMessage(<span className="alert alert-warning">{i18n.t('Je hebt het maximum beschikbare bereikt')}</span>)
                                        return q
                                    }
                                    return q+1
                                })}
                                id="button-minus"> 
                                +
                            </div>
                        </div>
                    
                        {product.available_listings <= 0 ?
                        <div className="badge mt-3 smr-bg-danger" style={{backgroundColor: 'var(--umr-danger)', width: 'fit-content'}}>
                                {i18n.t('Niet beschikbaar')}
                            </div>
                            :
                            <div className="badge mt-3 smr-bg-primary" style={{backgroundColor: 'var(--umr-primary)', width: 'fit-content'}}>
                                {i18n.t('Beschikbaar') +  ': ' + product.available_listings}
                            </div>
                        }
                    </div>
                </div>
            </div>
            {quantity > 0 && (
                <ProductOptions 
                    product={product} 
                    selectedOptions={selectedOptions}
                    onOptionsChange={(newOptions) => {
                        setSelectedOptions(newOptions)
                    }}
                />
            )}
        </div>
)
}

export default ProductReservationCard
